import { mapperGlobalDataCurrency } from '../../../core/data-layer/global-data/mappers'
import { mapperModuleMedia, mapperModuleNavigationLink } from '../../../core/data-layer/modules/mappers'
import { mapperBlockCallToAction } from '../../../core/data-layer/blocks/mappers'
import { getRelatedPaymentMethods } from '../../../core/data-layer/utils/mappers/pages'
import type { MapperOptions, ModuleMedia } from '#layers/core/types'

/**
 * Page content payments methods region country mapper
 * normalizes data to be used in pages
 *
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  const relatedPaymentMethods = getRelatedPaymentMethods(
    data.channelOnlineCollection?.items || [],
    data.channelInPersonCollection?.items || []
  )

  return {
    name: data.country?.name || '',
    regionName: data.country?.region?.name || '',
    shortDescription: data.shortDescription || '',
    longDescription: data.longDescription || null, // rich text
    image: mapperModuleMedia(data.image, options.imageOptions) as ModuleMedia,
    currency: mapperGlobalDataCurrency(data.currency),
    population: data.population || '',
    cardsPerCapita: data.cardsPerCapita || '',
    paymentsStatistics: data.paymentsStatistics || null,
    devicesStatistics:
      data.desktopStatistics && data.mobileStatistics
        ? { desktop: data.desktopStatistics, mobile: data.mobileStatistics }
        : null,
    callToAction: mapperBlockCallToAction(data.callToAction, options.getUrl),
    relatedPaymentMethods
  }
}
